import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { AccessibilityBrowserZoomSiteConfig } from '../types'

const accessibilityBrowserZoomSiteConfig: SiteConfigFn<AccessibilityBrowserZoomSiteConfig> = ({ api }) => {
	const siteMetaData = api.rendererModel.getSiteMetaData()
	const isBuilderComponentModel = !!siteMetaData?.builderComponentModel
	const isResponsive = siteMetaData?.isResponsive || false
	const isStudio = isResponsive && !isBuilderComponentModel

	const siteConfig: AccessibilityBrowserZoomSiteConfig = {
		isBuilder: isBuilderComponentModel,
		isStudio,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'accessibilityBrowserZoom'

export const config = { site: accessibilityBrowserZoomSiteConfig, name }
